/**
 * Estados del viaje y de sus paradas, y tipos de parada (compartidos por el ruteo, la integración con Mara y la torre).
 * Las reglas de transición están en docs/REGLAS.md.
 */

export const ESTADOS_VIAJE = ['PLANIFICADO', 'EN_CURSO', 'FINALIZADO', 'CANCELADO'] as const;
export type EstadoViaje = (typeof ESTADOS_VIAJE)[number];

/**
 * Estado de una parada del viaje (copia de una parada de la ruta asignada, tabla parada_viaje).
 * - PENDIENTE: todavía no se detectó ni se declaró.
 * - CUMPLIDA: detectada por GPS (entrada y salida del geofence) o declarada por Mara (`parada.registrada`).
 * - EXCEDIDA: cumplida, pero la permanencia superó la duración máxima esperada (la marca la regla PARADA_EXCEDIDA).
 * - OMITIDA: el viaje terminó sin detectarla ni declararla.
 * Ya no existe NO_CONFIRMADA: nadie confirma desde una app del TMS (D-36).
 */
export const ESTADOS_PARADA = ['PENDIENTE', 'CUMPLIDA', 'EXCEDIDA', 'OMITIDA'] as const;
export type EstadoParada = (typeof ESTADOS_PARADA)[number];

/** Tipo de parada de una ruta (lo define el despacho en el TMS). */
export const TIPOS_PARADA = ['CARGA', 'DESCARGA', 'COMBUSTIBLE', 'DESCANSO', 'CONTROL', 'OTRO'] as const;
export type TipoParada = (typeof TIPOS_PARADA)[number];
